import React, {Fragment, useMemo} from 'react';

// components
import {CardBorder} from '../../../shared/components';
import {Skeleton} from '@mui/joy';

// styles
import {
  CardPadding,
  InformationContainer,
  LabelContentWrapper,
  Separator,
} from './styles';
import {Subtitle} from '../../../shared/styles';

// hooks
import {useTheme} from '@emotion/react';

type Props = {
  numberOfLines: number;
};

const CardProfileSkeleton = ({numberOfLines}: Props) => {
  const {skeleton} = useTheme();

  const lines = useMemo(() => {
    return Array.from({length: numberOfLines}, (_, index) => (
      <Fragment key={index}>
        <LabelContentWrapper>
          <Skeleton variant="text" width={skeleton.text.width.lg} />
          <Skeleton variant="text" width={skeleton.text.width.xl} />
        </LabelContentWrapper>
        {index !== numberOfLines - 1 && <Separator />}
      </Fragment>
    ));
  }, [numberOfLines, skeleton]);

  return (
    <CardBorder variant="white">
      <CardPadding>
        <Subtitle>
          <Skeleton variant="text" width={skeleton.text.width.xl} />
        </Subtitle>
        <InformationContainer>{lines}</InformationContainer>
      </CardPadding>
    </CardBorder>
  );
};

export default CardProfileSkeleton;
